module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic19.fbe36d9.woff2";